// npm packages
import React from 'react';
import classNames from 'classnames';

// components
import Button from '../Button';
import Icon from '../Icon';

function ViewToggler({ icon, onClick }) {
  return (
    <Button
      type="outline"
      className={classNames(
        '!h-[32px] lg:!h-[40px] flex justify-center items-center bg-white !px-12 sm:!px-12 border !border-himalayan-poppy focus:!border-2 rounded-[100px]',
      )}
      onClick={onClick}
    >
      <Icon type={icon} className="size-[24px] lg:size-[24px]" />
    </Button>
  );
}

export default ViewToggler;
